import React from 'react'
import { ArrowBack as ArrowBackButton, Clear as CloseButtton } from '@material-ui/icons'
import { Breadcrumbs, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { GenealogicalDiagram } from 'src/components/GenealogicalDiagram'
import { IAnimal } from 'src/dto/animal.dto'
import { Separator } from 'src/assets/svg'

interface IGenealogy {
  closeGeneologyTree: () => void
  closeModalDetail: () => void
  dataAnimal: IAnimal
}

export const Genealogy = ({ closeGeneologyTree, closeModalDetail, dataAnimal }: IGenealogy) => {
  const styles = useStyles()
  return (
    <section style={{ height: 'calc(100% - 72px)' }}>
      <div className={styles.genealogyHeader}>
        <div className={styles.genealogyHeaderButtonsContainer}>
          <ArrowBackButton className={styles.icon} onClick={closeGeneologyTree} />
          <CloseButtton className={styles.icon} onClick={closeModalDetail} />
        </div>
        <div className={styles.genealogyHeaderBreadcrumbsContainer}>
          <Breadcrumbs separator={<Separator style={{ margin: '0 6px' }} />}>
            <Typography className={styles.breadcrumbsText} color='secondary'>
              {dataAnimal?.brinco || dataAnimal?.idAnimal}
            </Typography>
            <Typography className={styles.breadcrumbsText} color='primary'>
              Genealogia
            </Typography>
          </Breadcrumbs>
        </div>
      </div>
      <GenealogicalDiagram dataAnimal={dataAnimal} />
    </section>
  )
}
